module.exports = "/_next/static/images/icon_direction-24f4b23a49ffd0365d32884bf2d06163.svg";